module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEEAAACOCAMAAABZl5UWAAAAM1BMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACjBUbJAAAAEXRSTlMAMO9gIP+AEM+fv69wUECP33RaINwAAADaSURBVHgB7djRsYUgEIPhAK6AKtp/tdfBuQ0Qz7AP+UvYj5cAohATqJZotoIoF3uqGG+zXsFo1d52DHbYW8kYK9lbzMOO1ouBcOydhGMvkY5WIUfeMbGOx3THbb7jIkc5yvE7Rzmu0x3LfMdAOtq3jnKUoxzlKMc23fGa75hJx3uaI1gGfsPSh+zt7JZHLux7QOavGdh/FeD8Bwm06e3CtPKmlwvThsFkKlOZylSmMoUH09WFafBgWn5jKlOZyrS5ML140+rC9HZpKtMC0nTLAGVaQdXsANmCpz8o9BxBpfd3wwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/arrow_left.png
// module id = 9Rl2
// module chunks = 1